import { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Space, Table, Tag, message } from "antd";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import moment from "moment";
import NetworkApi from "../../network/networkApi";

const ReportSubmissionSettings = () => {
  const [settings, setSettings] = useState<any[]>([]);
  const [histories, setHistories] = useState<any[]>([]);
  const [changing, setChanging] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const load = async () => {
    const response = await NetworkApi.requestGet(
      "/api/admin/report-submission/settings",
    );
    if (response.resultCode !== 200) {
      message.error(response.message || "Тохиргоо татахад алдаа гарлаа");
      return;
    }
    setSettings(response.result?.settings || []);
    setHistories(response.result?.histories || []);
  };

  useEffect(() => {
    load();
  }, []);

  const openChange = (row: any) => {
    setChanging(row);
    form.resetFields();
  };

  const save = async ({ reason }: { reason: string }) => {
    if (!changing) return;
    setSaving(true);
    const response = await NetworkApi.requestPut(
      `/api/admin/report-submission/settings/${changing.reportType}`,
      { isOpen: !changing.isOpen, reason },
    );
    setSaving(false);
    if (response.resultCode !== 200) {
      return message.error(response.message || "Төлөв өөрчлөхөд алдаа гарлаа");
    }
    message.success(`${changing.label} ${changing.isOpen ? "хаагдлаа" : "нээгдлээ"}`);
    setChanging(null);
    form.resetFields();
    load();
  };

  const settingColumns = [
    { title: "Мэдээ", dataIndex: "label", key: "label" },
    {
      title: "Төлөв",
      dataIndex: "isOpen",
      key: "isOpen",
      render: (isOpen: boolean) => (
        <Tag color={isOpen ? "green" : "red"}>
          {isOpen ? "Нээлттэй" : "Хаалттай"}
        </Tag>
      ),
    },
    {
      title: "Сүүлд өөрчилсөн огноо",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (value: string) => (value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    {
      title: "Үйлдэл",
      key: "action",
      render: (_: unknown, row: any) => (
        <Button
          danger={row.isOpen}
          type={row.isOpen ? "primary" : "default"}
          icon={row.isOpen ? <LockOutlined /> : <UnlockOutlined />}
          onClick={() => openChange(row)}
        >
          {row.isOpen ? "Хаах" : "Нээх"}
        </Button>
      ),
    },
  ];

  const historyColumns = [
    {
      title: "Хийсэн үйлдэл",
      dataIndex: "action",
      render: (action: string, row: any) =>
        `${row.reportType === "cultivation" ? "Тариалалтын мэдээг" : "Ургац хураалтын мэдээг"} ${action === "opened" ? "нээсэн" : "хаасан"}`,
    },
    {
      title: "Огноо",
      dataIndex: "changedAt",
      render: (value: string) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Хэрэглэгчийн нэр",
      dataIndex: "changedByUser",
      render: (user: any) =>
        user ? [user.lastName, user.firstName].filter(Boolean).join(" ") || user.name || "-" : "-",
    },
    { title: "Шалтгаан", dataIndex: "reason" },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2>Мэдээ хүлээн авах тохиргоо</h2>
      <p style={{ color: "#666" }}>
        Хаалттай үед энгийн хэрэглэгч тариалалт, ургацын мэдээ нэмэх, засах, устгах боломжгүй. Супер админд хязгаарлалт үйлчлэхгүй.
      </p>
      <Table rowKey="reportType" columns={settingColumns} dataSource={settings} pagination={false} />

      <h3 style={{ marginTop: 28 }}>Өөрчлөлтийн түүх</h3>
      <Table rowKey="id" columns={historyColumns} dataSource={histories} pagination={{ pageSize: 20 }} />

      <Modal
        visible={!!changing}
        title={`${changing?.label || ""}-г ${changing?.isOpen ? "хаах" : "нээх"}`}
        onCancel={() => setChanging(null)}
        onOk={() => form.submit()}
        confirmLoading={saving}
        okText="Хадгалах"
        cancelText="Болих"
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={save}>
          <Form.Item
            name="reason"
            label="Шалтгаан"
            rules={[{ required: true, whitespace: true, message: "Шалтгаан оруулна уу" }]}
          >
            <Input.TextArea rows={4} placeholder="Төлөв өөрчилж буй шалтгаан" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ReportSubmissionSettings;
